import * as React from 'react';

import {
  type GeoLocation,
  cleanupMapResource,
} from '@/components/audit/widgets/company-gps-coordinates/utils';

export const useAutocomplete = (
  searchInputRef: React.MutableRefObject<HTMLInputElement | null>,
  onNewLocation: (location: GeoLocation) => void,
) => {
  const searchInstanceRef = React.useRef<google.maps.places.Autocomplete | null>(null);

  React.useEffect(() => {
    if (searchInputRef.current && !searchInstanceRef.current) {
      const autocomplete = new window.google.maps.places.Autocomplete(searchInputRef.current);
      searchInstanceRef.current = autocomplete;
      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (place?.geometry) {
          const latitude = place.geometry.location?.lat();
          const longitude = place.geometry.location?.lng();

          if (latitude && longitude) {
            onNewLocation({ latitude, longitude });
          }
        }
      });
    }

    return () => {
      cleanupMapResource(searchInstanceRef.current);
    };
  }, [onNewLocation, searchInputRef]);

  return searchInstanceRef.current;
};
